import debounce from "lodash.debounce";
import Image from "next/image";
import { RefObject, useCallback } from "react";

import { RestaurantItemType } from "../../../../api/types/restaurant.type";
import {
  getHereLocationData,
  getHerePredictions,
} from "../../../../utils/here";
import imageLoader from "../../../../utils/loader";
import { Position } from "../../../Menu/Restaurants";
import classes from "./input.module.scss";

interface Props {
  label: string;
  name: string;
  placeholder: string;
  setPosition: React.Dispatch<React.SetStateAction<Position>>;
  position: Position;
  inputRef: RefObject<HTMLInputElement>;
  restaurants: RestaurantItemType[];
}

const GoogleMapsInput = ({
  label,
  placeholder,
  setPosition,
  position,
  inputRef,
  restaurants,
}: Props) => {
  const getLocation = () => {
    navigator.geolocation.getCurrentPosition(function (position) {
      setPosition({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
    });
  };

  const handleSearch = async (value: string) => {
    if (value.length > 4) {
      const placeId = await getHerePredictions(value);
      if (placeId) {
        const { lat, lng } = await getHereLocationData(placeId);
        if (lat && lng)
          setPosition({
            lat,
            lng,
          });
      }
    }
  };

  const debouncedHandleSearch = useCallback(
    debounce((value: string) => {
      handleSearch(value);
    }, 500),
    [restaurants]
  );

  return (
    <div>
      <p className={classes.header}>{label}</p>
      <div className={classes.container}>
        <input
          placeholder={placeholder}
          className={`${classes.input}`}
          onChange={(event) => {
            debouncedHandleSearch(event.target.value);
          }}
          id="googleInput"
          ref={inputRef}
        />

        <div className={classes.leftLogo}>
          <Image
            loader={imageLoader}
            layout="fixed"
            width="24px"
            height="24px"
            src="search.svg"
            alt="search"
          />
        </div>
        <div className={classes.rightLogo} onClick={getLocation}>
          <Image
            loader={imageLoader}
            layout="fixed"
            width="25px"
            height="25px"
            src="location.png"
            alt="location"
          />
        </div>
      </div>
    </div>
  );
};

export default GoogleMapsInput;
